module.exports = __webpack_public_path__ + "static/media/MDP_Project_Intro_Slide_Screenshot.57a1cbf4.PNG";